import { render, staticRenderFns } from "./homeSchoolTwo.vue?vue&type=template&id=49cf6604&scoped=true"
import script from "./homeSchoolTwo.vue?vue&type=script&lang=js"
export * from "./homeSchoolTwo.vue?vue&type=script&lang=js"
import style0 from "./homeSchoolTwo.vue?vue&type=style&index=0&id=49cf6604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf6604",
  null
  
)

export default component.exports